import React from 'react';

import { cn, formatCurrency } from '@/lib/utils';

/**
 * Ce qu'une opération a coûté, ce qu'elle a rapporté, ce qu'il en reste.
 *
 * Le client demandait que « la finance reste explicite et brève sur l'ensemble
 * des opérations ». Elle était surtout absente là où les opérations se
 * regardent: l'écran d'un convoi n'affichait **aucun** chiffre alors que le
 * serveur calculait déjà sa marge, et l'écran d'un trajet montrait ses coûts
 * sans jamais sa recette.
 *
 * Trois nombres, une ligne, la même partout. Un quatrième nombre aurait
 * demandé un tableau, et un tableau se lit moins vite qu'une phrase.
 *
 * La couleur ne marque que l'état: une marge négative se voit, une marge
 * positive n'a pas besoin d'être verte pour être lue.
 */
export const LigneArgent = ({
  recette = 0,
  depenses = 0,
  marge = null,
  libelleRecette = 'Rapporté',
  libelleDepenses = 'Coûté',
  detail = null,
  className,
}) => {
  const resultat = marge == null ? recette - depenses : marge;
  const negative = resultat < 0;

  return (
    <div
      className={cn(
        'flex flex-wrap items-baseline gap-x-5 gap-y-1 rounded-xl border border-border/60 px-4 py-3',
        className,
      )}
    >
      <span className="text-sm text-muted-foreground">
        {libelleDepenses}{' '}
        <span className="font-semibold tabular-nums text-foreground">
          {formatCurrency(depenses)}
        </span>
      </span>
      <span className="text-sm text-muted-foreground">
        {libelleRecette}{' '}
        <span className="font-semibold tabular-nums text-foreground">
          {formatCurrency(recette)}
        </span>
      </span>
      <span
        className={cn(
          'text-sm font-semibold tabular-nums',
          negative ? 'text-destructive' : 'text-foreground',
        )}
      >
        Marge {formatCurrency(resultat)}
      </span>
      {detail ? (
        <span className="w-full text-xs text-muted-foreground">{detail}</span>
      ) : null}
    </div>
  );
};

export default LigneArgent;
